import glObjectService from 'Infrastructure/Service/GLObjectService';
import { meshSelectionStore } from 'Domain/Mesh/State/MeshSelectionStore';

class ToothOffsetManager {
    constructor() {
        this.defaultOffset = 0.5;
    }

    async applyOffsetToToothKeepIndices(tooth, offset = this.defaultOffset) {
        if (!tooth) {
            throw new Error('Tooth is required');
        }

        const toothMesh = this._extractToothMesh(tooth);
        if (!toothMesh) {
            throw new Error('Tooth has no mesh');
        }

        return await glObjectService.applyOffsetToMeshKeepIndices(toothMesh, offset);
    }

    async applyOffsetToSelectedToothKeepIndices(offset = this.defaultOffset) {
        const selectedTooth = this._getSelectedTooth();
        if (!selectedTooth) {
            throw new Error('No tooth selected');
        }

        const toothMesh = this._extractToothMesh(selectedTooth);
        if (!toothMesh) {
            throw new Error('Selected tooth has no mesh');
        }

        return await glObjectService.applyOffsetToMeshKeepIndices(toothMesh, offset);
    }

    setDefaultOffset(offset) {
        if (typeof offset !== 'number' || isNaN(offset)) {
            throw new Error('Offset must be a valid number');
        }
        this.defaultOffset = offset;
    }

    getDefaultOffset() {
        return this.defaultOffset;
    }

    _getSelectedTooth() {
        return meshSelectionStore.getClickedTooth();
    }

    _extractToothMesh(tooth) {
        if (tooth.mesh) {
            return tooth.mesh;
        }
        
        if (tooth.pivot && tooth.pivot.children) {
            const meshChild = tooth.pivot.children.find(child => child.isMesh);
            if (meshChild) {
                return meshChild;
            }
        }
        
        return null;
    }
}

const toothOffsetManager = new ToothOffsetManager();
export default toothOffsetManager;
export { ToothOffsetManager };
